import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_9 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_10 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_11 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_12 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_15 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_16 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_23 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_24 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_25 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_26 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_27 = { class: "ant-row" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-14" }
const _hoisted_29 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_30 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_31 = { class: "ant-row" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_33 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_34 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_35 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_36 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_37 = { class: "ant-row" }
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-14" }
const _hoisted_39 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_40 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_41 = { class: "ant-row" }
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_43 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_44 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_45 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_46 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_47 = { class: "ant-row" }
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_49 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_50 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_51 = { class: "ant-row" }
const _hoisted_52 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_53 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_54 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_55 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_56 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_57 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_58 = { class: "ant-row" }
const _hoisted_59 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_60 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_61 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_62 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_63 = { class: "ant-row" }
const _hoisted_64 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_69 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }
const _hoisted_70 = { class: "ant-row" }
const _hoisted_71 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_72 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_73 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_74 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_75 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_76 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_77 = { class: "ant-row" }
const _hoisted_78 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_79 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_80 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_81 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_82 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_83 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_84 = { class: "ant-row" }
const _hoisted_85 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_86 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_87 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_88 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_89 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_90 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_91 = { class: "ant-row" }
const _hoisted_92 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_cst_icms = _resolveComponent("selecionar-cst-icms")!
  const _component_selecionar_csosn = _resolveComponent("selecionar-csosn")!
  const _component_selecionar_origem_mercadoria = _resolveComponent("selecionar-origem-mercadoria")!
  const _component_selecionar_modalidade_base_calculo_icms = _resolveComponent("selecionar-modalidade-base-calculo-icms")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_card = _resolveComponent("card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_selecionar_cst_ipi = _resolveComponent("selecionar-cst-ipi")!
  const _component_selecionar_codigo_enquadramento_ipi = _resolveComponent("selecionar-codigo-enquadramento-ipi")!
  const _component_selecionar_tipo_calculo_imposto = _resolveComponent("selecionar-tipo-calculo-imposto")!
  const _component_selecionar_cst_pis = _resolveComponent("selecionar-cst-pis")!
  const _component_selecionar_cst_cofins = _resolveComponent("selecionar-cst-cofins")!
  const _component_selecionar_modalidade_base_calculo_icms_substituicao = _resolveComponent("selecionar-modalidade-base-calculo-icms-substituicao")!
  const _component_selecionar_cest = _resolveComponent("selecionar-cest")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tabs, {
              class: "ss-card",
              defaultActiveKey: "1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "1",
                  tab: "ICMS"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_a_form_item, {
                              label: " ",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_group, {
                                  value: _ctx.state.definirCst,
                                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.definirCst) = $event)),
                                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.definePreenchimentoCstCsosn())),
                                  "button-style": "solid"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio_button, { value: true }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("CST")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio_button, { value: false }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("CSOSN")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_a_form_item, {
                              label: _ctx.state.definirCst ? 'Código da Situação Tributária' : 'Código de Situação da Operação do Simples Nacional',
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.state.definirCst)
                                  ? (_openBlock(), _createBlock(_component_selecionar_cst_icms, {
                                      key: 0,
                                      codigoSelecionado: _ctx.computedImpostos.cst,
                                      "onUpdate:codigoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedImpostos.cst) = $event)),
                                      disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal(),
                                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["codigoSelecionado", "disabled"]))
                                  : (_openBlock(), _createBlock(_component_selecionar_csosn, {
                                      key: 1,
                                      codigoSelecionado: _ctx.computedImpostos.cson,
                                      "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedImpostos.cson) = $event)),
                                      disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal(),
                                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["codigoSelecionado", "disabled"]))
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_a_form_item, {
                              label: "Origem da Mercadoria",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_origem_mercadoria, {
                                  codigoSelecionado: _ctx.computedImpostos.origemMercadoria,
                                  "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedImpostos.origemMercadoria) = $event)),
                                  disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal(),
                                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["codigoSelecionado", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_a_form_item, {
                              label: "Cód. do Benefício Fiscal",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.computedImpostos.codigoBeneficioFiscal) = $event)),
                                  disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal()
                                }, null, 8, _hoisted_7), [
                                  [_vModelText, _ctx.computedImpostos.codigoBeneficioFiscal]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_a_form_item, {
                              label: "Modalidade da B.C do ICMS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_modalidade_base_calculo_icms, {
                                  codigoSelecionado: _ctx.computedImpostos.icms.modalidadeBaseCalculoIcms,
                                  "onUpdate:codigoSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.computedImpostos.icms.modalidadeBaseCalculoIcms) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["codigoSelecionado", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_a_form_item, {
                              label: "Redução da B.C de ICMS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  percentual: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.icms.reducaoBaseCalculoIcms,
                                  "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedImpostos.icms.reducaoBaseCalculoIcms) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_a_form_item, {
                              label: "B.C do ICMS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.icms.baseCalculoIcms,
                                  "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.computedImpostos.icms.baseCalculoIcms) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_a_form_item, {
                              label: "Alíquota do ICMS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  percentual: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.icms.aliquotaIcms,
                                  "onUpdate:valor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.computedImpostos.icms.aliquotaIcms) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_a_form_item, {
                              label: "Valor do ICMS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.icms.valorIcms,
                                  "onUpdate:valor": [
                                    _cache[17] || (_cache[17] = ($event: any) => ((_ctx.computedImpostos.icms.valorIcms) = $event)),
                                    _ctx.atualizarTotalImpostos
                                  ],
                                  disabled: !_ctx.props.editavel,
                                  onBlur: _ctx.calcular
                                }, null, 8, ["valor", "disabled", "onUpdate:valor", "onBlur"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createVNode(_component_card, { titulo: "ICMS Interestadual" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_a_form_item, {
                                  label: "Calcular DIFAL",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_sim_nao, {
                                      valor: _ctx.computedImpostos.icms.calcularIcmsInterestadual,
                                      "onUpdate:valor": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.computedImpostos.icms.calcularIcmsInterestadual) = $event)),
                                      radioButton: true,
                                      disabled: !_ctx.props.editavel
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_a_form_item, {
                                  label: "Deduzir ICMS",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_sim_nao, {
                                      valor: _ctx.computedImpostos.icms.deduzirIcmsInterestadual,
                                      "onUpdate:valor": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.computedImpostos.icms.deduzirIcmsInterestadual) = $event)),
                                      radioButton: true,
                                      disabled: !_ctx.props.editavel
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_a_form_item, {
                                  label: "Alíquota da UF de Destino",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      percentual: true,
                                      valor: _ctx.computedImpostos.icms.aliquotaDestino,
                                      "onUpdate:valor": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.computedImpostos.icms.aliquotaDestino) = $event))
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "2",
                  tab: "IPI"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_a_form_item, {
                              label: "CST - Código da Situação Tributária do IPI",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_cst_ipi, {
                                  codigoSelecionado: _ctx.computedImpostos.ipi.cstIpi,
                                  "onUpdate:codigoSelecionado": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.computedImpostos.ipi.cstIpi) = $event)),
                                  disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal(),
                                  onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["codigoSelecionado", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_a_form_item, {
                              label: "Enquadramento Fiscal do IPI",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_codigo_enquadramento_ipi, {
                                  codigoSelecionado: _ctx.computedImpostos.ipi.codigoEnquadramentoIpi,
                                  "onUpdate:codigoSelecionado": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.computedImpostos.ipi.codigoEnquadramentoIpi) = $event)),
                                  disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal()
                                }, null, 8, ["codigoSelecionado", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_a_form_item, {
                              label: "Qtd de Unidades Tributáveis",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.ipi.quantidadeUnidadeTributavelIpi,
                                  "onUpdate:valor": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.computedImpostos.ipi.quantidadeUnidadeTributavelIpi) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_a_form_item, {
                              label: "Tipo de Cálculo",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_tipo_calculo_imposto, {
                                  codigoSelecionado: _ctx.computedImpostos.ipi.tipoCalculoIpi,
                                  "onUpdate:codigoSelecionado": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.computedImpostos.ipi.tipoCalculoIpi) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["codigoSelecionado", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_a_form_item, {
                              label: "Base de Cálculo do IPI",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.ipi.baseCalculoIpi,
                                  "onUpdate:valor": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.computedImpostos.ipi.baseCalculoIpi) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_a_form_item, {
                              label: "Alíquota do IPI",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  percentual: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.ipi.aliquotaIpi,
                                  "onUpdate:valor": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.computedImpostos.ipi.aliquotaIpi) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_a_form_item, {
                              label: "Valor do IPI",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.ipi.valorIpi,
                                  "onUpdate:valor": [
                                    _cache[32] || (_cache[32] = ($event: any) => ((_ctx.computedImpostos.ipi.valorIpi) = $event)),
                                    _ctx.atualizarTotalImpostos
                                  ],
                                  onBlur: _ctx.calcular,
                                  disabled: !_ctx.props.editavel
                                }, null, 8, ["valor", "onUpdate:valor", "onBlur", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_a_form_item, {
                              label: "Vlr do IPI por Unid. Trib.",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.ipi.valorUnidadeTributavelIpi,
                                  "onUpdate:valor": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.computedImpostos.ipi.valorUnidadeTributavelIpi) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "3",
                  tab: "PIS"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_component_a_form_item, {
                              label: "CST - Código da Situação Tributária do PIS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_cst_pis, {
                                  codigoSelecionado: _ctx.computedImpostos.pis.cstPis,
                                  "onUpdate:codigoSelecionado": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.computedImpostos.pis.cstPis) = $event)),
                                  disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal(),
                                  onChange: _cache[36] || (_cache[36] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["codigoSelecionado", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_a_form_item, {
                              label: "Redução da B.C do PIS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  percentual: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.pis.reducaoBaseCalculoPis,
                                  "onUpdate:valor": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.computedImpostos.pis.reducaoBaseCalculoPis) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_a_form_item, {
                              label: "Qtd de Un Tributáveis",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.pis.quantidadeUnidadeTributavelPis,
                                  "onUpdate:valor": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.computedImpostos.pis.quantidadeUnidadeTributavelPis) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[40] || (_cache[40] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_a_form_item, {
                              label: "Tipo de Cálculo",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_tipo_calculo_imposto, {
                                  codigoSelecionado: _ctx.computedImpostos.pis.tipoCalculoPis,
                                  "onUpdate:codigoSelecionado": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.computedImpostos.pis.tipoCalculoPis) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["codigoSelecionado", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_a_form_item, {
                              label: "Base de Cálculo do PIS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.pis.baseCalculoPis,
                                  "onUpdate:valor": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.computedImpostos.pis.baseCalculoPis) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[44] || (_cache[44] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_a_form_item, {
                              label: "Alíquota do PIS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  percentual: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.pis.aliquotaPis,
                                  "onUpdate:valor": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.computedImpostos.pis.aliquotaPis) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[46] || (_cache[46] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_a_form_item, {
                              label: "Valor do PIS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.pis.valorPis,
                                  "onUpdate:valor": [
                                    _cache[47] || (_cache[47] = ($event: any) => ((_ctx.computedImpostos.pis.valorPis) = $event)),
                                    _ctx.atualizarTotalImpostos
                                  ],
                                  onBlur: _ctx.calcular,
                                  disabled: !_ctx.props.editavel
                                }, null, 8, ["valor", "onUpdate:valor", "onBlur", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createVNode(_component_a_form_item, {
                              label: "Vlr do PIS por Unid. Trib.",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.pis.valorUnidadeTributavelPis,
                                  "onUpdate:valor": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.computedImpostos.pis.valorUnidadeTributavelPis) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[49] || (_cache[49] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "4",
                  tab: "COFINS"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(_component_a_form_item, {
                              label: "CST - Código da Situação Tributária do COFINS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_cst_cofins, {
                                  codigoSelecionado: _ctx.computedImpostos.cofins.cstCofins,
                                  "onUpdate:codigoSelecionado": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.computedImpostos.cofins.cstCofins) = $event)),
                                  disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal(),
                                  onChange: _cache[51] || (_cache[51] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["codigoSelecionado", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_a_form_item, {
                              label: "Red. da B.C do COFINS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  percentual: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.cofins.reducaoBaseCalculoCofins,
                                  "onUpdate:valor": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.computedImpostos.cofins.reducaoBaseCalculoCofins) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[53] || (_cache[53] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createVNode(_component_a_form_item, {
                              label: "Qtd de Un Tributáveis",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.cofins.quantidadeUnidadeTributavelCofins,
                                  "onUpdate:valor": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.computedImpostos.cofins.quantidadeUnidadeTributavelCofins) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[55] || (_cache[55] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createVNode(_component_a_form_item, {
                              label: "Tipo de Cálculo",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_tipo_calculo_imposto, {
                                  codigoSelecionado: _ctx.computedImpostos.cofins.tipoCalculoCofins,
                                  "onUpdate:codigoSelecionado": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.computedImpostos.cofins.tipoCalculoCofins) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[57] || (_cache[57] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["codigoSelecionado", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createVNode(_component_a_form_item, {
                              label: "B.C do COFINS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.cofins.baseCalculoCofins,
                                  "onUpdate:valor": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.computedImpostos.cofins.baseCalculoCofins) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[59] || (_cache[59] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createVNode(_component_a_form_item, {
                              label: "Alíq. do COFINS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  percentual: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.cofins.aliquotaCofins,
                                  "onUpdate:valor": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.computedImpostos.cofins.aliquotaCofins) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[61] || (_cache[61] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _createVNode(_component_a_form_item, {
                              label: "Valor do COFINS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.cofins.valorCofins,
                                  "onUpdate:valor": [
                                    _cache[62] || (_cache[62] = ($event: any) => ((_ctx.computedImpostos.cofins.valorCofins) = $event)),
                                    _ctx.atualizarTotalImpostos
                                  ],
                                  onBlur: _ctx.calcular,
                                  disabled: !_ctx.props.editavel
                                }, null, 8, ["valor", "onUpdate:valor", "onBlur", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_a_form_item, {
                              label: "Vlr do COFINS por Unid.",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.pis.valorUnidadeTributavelPis,
                                  "onUpdate:valor": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.computedImpostos.pis.valorUnidadeTributavelPis) = $event)),
                                  disabled: !_ctx.props.editavel
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "5",
                  tab: "SUBSTITUIÇÃO TRIBUTÁRIA"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_a_form_item, {
                              label: "Modalidade da B.C do ICMS ST",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_modalidade_base_calculo_icms_substituicao, {
                                  codigoSelecionado: _ctx.computedImpostos.st.modalidadeBaseCalculoSubstituicao,
                                  "onUpdate:codigoSelecionado": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.computedImpostos.st.modalidadeBaseCalculoSubstituicao) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[65] || (_cache[65] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["codigoSelecionado", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_component_a_form_item, {
                              label: "MVA",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  percentual: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.st.margemValorAdicionado,
                                  "onUpdate:valor": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.computedImpostos.st.margemValorAdicionado) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[67] || (_cache[67] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _createVNode(_component_a_form_item, {
                              label: "CEST - Código Escificador da Substituição Tributária",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_cest, {
                                  codigoSelecionado: _ctx.computedImpostos.st.cest,
                                  "onUpdate:codigoSelecionado": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.computedImpostos.st.cest) = $event)),
                                  disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal()
                                }, null, 8, ["codigoSelecionado", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createVNode(_component_a_form_item, {
                              label: "Pauta do ICMS ST",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  percentual: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.st.pautaIcmsSubstituicao,
                                  "onUpdate:valor": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.computedImpostos.st.pautaIcmsSubstituicao) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[70] || (_cache[70] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _createVNode(_component_a_form_item, {
                              label: "Alíq. do ICMS Interno",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  percentual: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.st.aliquotaIcmsInterno,
                                  "onUpdate:valor": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.computedImpostos.st.aliquotaIcmsInterno) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[72] || (_cache[72] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(_component_a_form_item, {
                              label: "Red. da B.C do ICMS ST",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  percentual: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.st.reducaoBaseCalculoSubstituicao,
                                  "onUpdate:valor": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.computedImpostos.st.reducaoBaseCalculoSubstituicao) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[74] || (_cache[74] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _createVNode(_component_a_form_item, {
                              label: "BC do ICMS ST",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.st.baseCalculoSubstituicaoTributaria,
                                  "onUpdate:valor": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.computedImpostos.st.baseCalculoSubstituicaoTributaria) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[76] || (_cache[76] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _createVNode(_component_a_form_item, {
                              label: "Alíquota do ICMS ST",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  percentual: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.st.aliquotaSubstituicaoTributaria,
                                  "onUpdate:valor": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.computedImpostos.st.aliquotaSubstituicaoTributaria) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[78] || (_cache[78] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _createVNode(_component_a_form_item, {
                              label: "Vlr do ICMS ST",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.st.valorSubstituicaoTributaria,
                                  "onUpdate:valor": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.computedImpostos.st.valorSubstituicaoTributaria) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[80] || (_cache[80] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "6",
                  tab: "IMPORTAÇÃO"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_a_form_item, {
                              label: "Base de Cálculo",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.importacao.baseCalculoImportacao,
                                  "onUpdate:valor": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.computedImpostos.importacao.baseCalculoImportacao) = $event)),
                                  disabled: !_ctx.props.editavel
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _createVNode(_component_a_form_item, {
                              label: "Despesas Aduaneiras",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.importacao.despesasAduaneiras,
                                  "onUpdate:valor": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.computedImpostos.importacao.despesasAduaneiras) = $event)),
                                  disabled: !_ctx.props.editavel
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _createVNode(_component_a_form_item, {
                              label: "Vlr do II",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.importacao.valorImportacao,
                                  "onUpdate:valor": [
                                    _cache[83] || (_cache[83] = ($event: any) => ((_ctx.computedImpostos.importacao.valorImportacao) = $event)),
                                    _ctx.atualizarTotalImpostos
                                  ],
                                  onBlur: _ctx.calcular,
                                  disabled: !_ctx.props.editavel
                                }, null, 8, ["valor", "onUpdate:valor", "onBlur", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _createVNode(_component_a_form_item, {
                              label: "Valor do IOF",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.importacao.valorIof,
                                  "onUpdate:valor": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.computedImpostos.importacao.valorIof) = $event)),
                                  disabled: !_ctx.props.editavel
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "7",
                  tab: "IBS/CBS"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _createVNode(_component_a_form_item, {
                              label: "CST",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.codigoSituacaoTributaria) = $event)),
                                  disabled: !_ctx.props.editavel
                                }, null, 8, _hoisted_65), [
                                  [_vModelText, _ctx.computedImpostos.ibsCbs.codigoSituacaoTributaria]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _createVNode(_component_a_form_item, {
                              label: "Classificação Tributária",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.codigoClassificacaoTributaria) = $event)),
                                  disabled: !_ctx.props.editavel
                                }, null, 8, _hoisted_67), [
                                  [_vModelText, _ctx.computedImpostos.ibsCbs.codigoClassificacaoTributaria]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_68, [
                            _createVNode(_component_a_form_item, {
                              label: "Indicador Doação",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  valor: _ctx.computedImpostos.ibsCbs.indicadorDoacao,
                                  "onUpdate:valor": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.indicadorDoacao) = $event)),
                                  disabled: !_ctx.props.editavel
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_69, [
                            _createVNode(_component_a_form_item, {
                              label: "B.C do IBS/CBS",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_numerico, {
                                  monetario: true,
                                  quantidadeCasasDecimais: 2,
                                  valor: _ctx.computedImpostos.ibsCbs.valorBaseCalculoIbsCbs,
                                  "onUpdate:valor": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.valorBaseCalculoIbsCbs) = $event)),
                                  disabled: !_ctx.props.editavel,
                                  onChange: _cache[89] || (_cache[89] = ($event: any) => (_ctx.calcularTributacoes()))
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createVNode(_component_card, { titulo: "IBS (UF)" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_70, [
                              _createElementVNode("div", _hoisted_71, [
                                _createVNode(_component_a_form_item, {
                                  label: "Alíquota UF",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      percentual: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.aliquotaIbsUf,
                                      "onUpdate:valor": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.aliquotaIbsUf) = $event)),
                                      disabled: !_ctx.props.editavel,
                                      onChange: _cache[91] || (_cache[91] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_72, [
                                _createVNode(_component_a_form_item, {
                                  label: "Redução Alíquota UF",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      percentual: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.percentualReducaoAliquotaIbsUf,
                                      "onUpdate:valor": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.percentualReducaoAliquotaIbsUf) = $event)),
                                      disabled: !_ctx.props.editavel,
                                      onChange: _cache[93] || (_cache[93] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_73, [
                                _createVNode(_component_a_form_item, {
                                  label: "Alíquota Efetiva UF",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      percentual: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.aliquotaEfetivaIbsUf,
                                      "onUpdate:valor": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.aliquotaEfetivaIbsUf) = $event)),
                                      disabled: !_ctx.props.editavel,
                                      onChange: _cache[95] || (_cache[95] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_74, [
                                _createVNode(_component_a_form_item, {
                                  label: "Valor IBS UF",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.valorIbsUf,
                                      "onUpdate:valor": [
                                        _cache[96] || (_cache[96] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.valorIbsUf) = $event)),
                                        _ctx.atualizarTotalImpostos
                                      ],
                                      onBlur: _ctx.calcular,
                                      disabled: !_ctx.props.editavel
                                    }, null, 8, ["valor", "onUpdate:valor", "onBlur", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_75, [
                                _createVNode(_component_a_form_item, {
                                  label: "Diferimento UF",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.valorDiferimentoIbsUf,
                                      "onUpdate:valor": _cache[97] || (_cache[97] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.valorDiferimentoIbsUf) = $event)),
                                      disabled: !_ctx.props.editavel,
                                      onChange: _cache[98] || (_cache[98] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_76, [
                                _createVNode(_component_a_form_item, {
                                  label: "Devolução Tributo UF",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.valorDevolucaoTributoIbsUf,
                                      "onUpdate:valor": _cache[99] || (_cache[99] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.valorDevolucaoTributoIbsUf) = $event)),
                                      disabled: !_ctx.props.editavel,
                                      onChange: _cache[100] || (_cache[100] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_card, { titulo: "IBS (Município)" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("div", _hoisted_78, [
                                _createVNode(_component_a_form_item, {
                                  label: "Alíquota Mun.",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      percentual: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.aliquotaIbsMunicipio,
                                      "onUpdate:valor": _cache[101] || (_cache[101] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.aliquotaIbsMunicipio) = $event)),
                                      disabled: !_ctx.props.editavel,
                                      onChange: _cache[102] || (_cache[102] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_79, [
                                _createVNode(_component_a_form_item, {
                                  label: "Redução Alíquota Mun.",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      percentual: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.percentualReducaoAliquotaIbsMunicipio,
                                      "onUpdate:valor": _cache[103] || (_cache[103] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.percentualReducaoAliquotaIbsMunicipio) = $event)),
                                      disabled: !_ctx.props.editavel,
                                      onChange: _cache[104] || (_cache[104] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_80, [
                                _createVNode(_component_a_form_item, {
                                  label: "Alíquota Efetiva Mun.",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      percentual: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.aliquotaEfetivaIbsMunicipio,
                                      "onUpdate:valor": _cache[105] || (_cache[105] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.aliquotaEfetivaIbsMunicipio) = $event)),
                                      disabled: !_ctx.props.editavel,
                                      onChange: _cache[106] || (_cache[106] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_81, [
                                _createVNode(_component_a_form_item, {
                                  label: "Valor IBS Mun.",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.valorIbsMunicipio,
                                      "onUpdate:valor": [
                                        _cache[107] || (_cache[107] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.valorIbsMunicipio) = $event)),
                                        _ctx.atualizarTotalImpostos
                                      ],
                                      onBlur: _ctx.calcular,
                                      disabled: !_ctx.props.editavel
                                    }, null, 8, ["valor", "onUpdate:valor", "onBlur", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_82, [
                                _createVNode(_component_a_form_item, {
                                  label: "Diferimento Mun.",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.valorDiferimentoIbsMunicipio,
                                      "onUpdate:valor": _cache[108] || (_cache[108] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.valorDiferimentoIbsMunicipio) = $event)),
                                      disabled: !_ctx.props.editavel,
                                      onChange: _cache[109] || (_cache[109] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_83, [
                                _createVNode(_component_a_form_item, {
                                  label: "Devolução Tributo Mun.",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.valorDevolucaoTributoIbsMunicipio,
                                      "onUpdate:valor": _cache[110] || (_cache[110] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.valorDevolucaoTributoIbsMunicipio) = $event)),
                                      disabled: !_ctx.props.editavel,
                                      onChange: _cache[111] || (_cache[111] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_card, { titulo: "CBS (Federal)" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_84, [
                              _createElementVNode("div", _hoisted_85, [
                                _createVNode(_component_a_form_item, {
                                  label: "Alíquota CBS",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      percentual: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.aliquotaCbs,
                                      "onUpdate:valor": _cache[112] || (_cache[112] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.aliquotaCbs) = $event)),
                                      disabled: !_ctx.props.editavel,
                                      onChange: _cache[113] || (_cache[113] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_86, [
                                _createVNode(_component_a_form_item, {
                                  label: "Redução Alíquota CBS",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      percentual: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.percentualReducaoAliquotaCbs,
                                      "onUpdate:valor": _cache[114] || (_cache[114] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.percentualReducaoAliquotaCbs) = $event)),
                                      disabled: !_ctx.props.editavel,
                                      onChange: _cache[115] || (_cache[115] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_87, [
                                _createVNode(_component_a_form_item, {
                                  label: "Alíquota Efetiva CBS",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      percentual: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.aliquotaEfetivaCbs,
                                      "onUpdate:valor": _cache[116] || (_cache[116] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.aliquotaEfetivaCbs) = $event)),
                                      disabled: !_ctx.props.editavel,
                                      onChange: _cache[117] || (_cache[117] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_88, [
                                _createVNode(_component_a_form_item, {
                                  label: "Valor CBS",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.valorCbs,
                                      "onUpdate:valor": [
                                        _cache[118] || (_cache[118] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.valorCbs) = $event)),
                                        _ctx.atualizarTotalImpostos
                                      ],
                                      onBlur: _ctx.calcular,
                                      disabled: !_ctx.props.editavel
                                    }, null, 8, ["valor", "onUpdate:valor", "onBlur", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_89, [
                                _createVNode(_component_a_form_item, {
                                  label: "Diferimento CBS",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.valorDiferimentoCbs,
                                      "onUpdate:valor": _cache[119] || (_cache[119] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.valorDiferimentoCbs) = $event)),
                                      disabled: !_ctx.props.editavel,
                                      onChange: _cache[120] || (_cache[120] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_90, [
                                _createVNode(_component_a_form_item, {
                                  label: "Devolução Tributo CBS",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.valorDevolucaoTributoCbs,
                                      "onUpdate:valor": _cache[121] || (_cache[121] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.valorDevolucaoTributoCbs) = $event)),
                                      disabled: !_ctx.props.editavel,
                                      onChange: _cache[122] || (_cache[122] = ($event: any) => (_ctx.calcularTributacoes()))
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_card, { titulo: "Consolidado" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_91, [
                              _createElementVNode("div", _hoisted_92, [
                                _createVNode(_component_a_form_item, {
                                  label: "Valor IBS Total",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      quantidadeCasasDecimais: 2,
                                      valor: _ctx.computedImpostos.ibsCbs.valorIbsTotal,
                                      "onUpdate:valor": _cache[123] || (_cache[123] = ($event: any) => ((_ctx.computedImpostos.ibsCbs.valorIbsTotal) = $event)),
                                      disabled: !_ctx.props.editavel
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}